import React, { useRef, useState } from 'react';
import {func, string} from 'prop-types';
import classnames from 'classnames';

import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';

import './FilePicker.css';

export default function FilePicker({className, accept = '*', onSelect}) {
  const fileSelectorRef = useRef(null);
  const [fileSelected, setFileSelected] = useState(false);

  function handleClick(ev) {
    ev.preventDefault();
    fileSelectorRef.current.click();
  }

  function handleInputChange(ev) {
    const file = ev.target.files[0];
    setFileSelected(true);
    onSelect(file);
  }

  return (
    <div className={classnames("FilePicker", className)}>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClick}
      >
        {fileSelected ? <CheckIcon style={{paddingRight: 5}} /> : null}
        Pick file
      </Button>
      <input ref={fileSelectorRef} type="file" accept={accept} hidden onChange={handleInputChange} />
    </div>
  )
}

FilePicker.propTypes = {
  className: string,
  onSelect: func
}
